import { render, staticRenderFns } from "./cartao.mensagem.component.vue?vue&type=template&id=23ac4719&scoped=true&"
import script from "./cartao.mensagem.component.vue?vue&type=script&lang=js&"
export * from "./cartao.mensagem.component.vue?vue&type=script&lang=js&"
import style0 from "./cartao.mensagem.component.vue?vue&type=style&index=0&id=23ac4719&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac4719",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/webroot/appsobdemanda/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ac4719')) {
      api.createRecord('23ac4719', component.options)
    } else {
      api.reload('23ac4719', component.options)
    }
    module.hot.accept("./cartao.mensagem.component.vue?vue&type=template&id=23ac4719&scoped=true&", function () {
      api.rerender('23ac4719', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/cartao.mensagem.component.vue"
export default component.exports